import React from "react";
import Kabila from "../../components/Kabila/Kabila.jsx";
import "./clubs.css";

const Clubs = () => {
  return (
    <section>
      <h1 className="title">
        Clubs <span> And </span> Committees
      </h1>
      <Kabila />
    </section>
  );
};

export default Clubs;
